import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Tooltip from 'flarum/common/components/Tooltip';
export default class LevelBar extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const user = this.attrs.user;
    const pointsText = app.forum.attribute('ianm-level-ranks.pointsText') || app.translator.trans('ianm-level-ranks.lib.defaults.level');
    let expComments = (user.commentCount() - user.discussionCount()) * 21,
      expDiscussions = user.discussionCount() * 33;
    let expTotal = expComments + expDiscussions,
      expLevel = Math.floor(expTotal / 135),
      expPercent = 100 / 135 * (expTotal - expLevel * 135);
    return m(Tooltip, {
      text: app.translator.trans('ianm-level-ranks.forum.desc.expText', {
        expTotal
      })
    }, m("div", {
      class: "PostUser-level"
    }, m("span", {
      class: "PostUser-text"
    }, m("span", {
      class: "PostUser-levelText"
    }, pointsText), "\xA0", m("span", {
      class: "PostUser-levelPoints"
    }, expLevel)), m("div", {
      class: "PostUser-bar PostUser-bar--empty"
    }), m("div", {
      class: "PostUser-bar",
      style: 'width: ' + expPercent + '%;'
    })));
  }
}
flarum.reg.add('ianm-level-ranks', 'forum/components/LevelBar', LevelBar);